import React from 'react';

interface NewChatButtonProps {
  onClick: () => void;
}

const NewChatButton: React.FC<NewChatButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center justify-center h-12 px-4 rounded-xl bg-gray-700 hover:bg-gray-600 text-gray-300 font-semibold transition-all duration-200 border-2 border-gray-600"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5 mr-2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      New Chat
    </button>
  );
};

export default NewChatButton;
